import type {
  ClientPostCreateConfirmation,
  ClientPostCreationCreateRequest
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { GrapevinePostCreationApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

import { POST_MUTATION_KEYS } from '@/features/api/constants/mutation';
import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';
import { invalidatePostCachesForNewPost } from '@/features/api/utils/postCaches';

export const useCreatePostCreation = () => {
  const queryClient = useQueryClient();
  const configuration = useApiConfiguration();
  const api = useMemo(
    () => new GrapevinePostCreationApi(configuration),
    [configuration]
  );

  return useApiMutation<
    ClientPostCreateConfirmation,
    unknown,
    ClientPostCreationCreateRequest
  >({
    mutationKey: [POST_MUTATION_KEYS.CREATE],
    errorMessageKey: 'createPost.error',
    mutationFn: (clientPostCreationCreateRequest) =>
      api.create({ clientPostCreationCreateRequest }),
    onSuccess: ({ post }) => invalidatePostCachesForNewPost(queryClient, post)
  });
};
